var map = {
	"./Facebook.png": "6fb6",
	"./Instagram.png": "c191",
	"./Linkedin.png": "ab0c",
	"./Telegram.png": "6a2b",
	"./Twitter.png": "87a7",
	"./Whatsapp.png": "fd05",
	"./YouTube.png": "4b5a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "979c";